<template>
  <div class="content-430">
    <div class="class-form-head">课程详情</div>
    <div class="class-form-content">
      <Form
        ref="courseDetailInfo"
        :model="courseDetailInfo"
        label-position="right"
        :label-width="120"
        :rules="courseDetailInfoRule"
        @on-validate="getFormValidate"
      >
        <FormItem label="课程封面" prop="courseCoverShow">
          <div class="flex upload">
            <div v-if="courseDetailInfo.courseCoverShow" class="imgBox">
              <div class="rightBox"></div>
              <img
                v-if="courseDetailInfo.courseCoverShow.fileId"
                :src="
                  downloadUrl +
                    '?fileId=' +
                    courseDetailInfo.courseCoverShow.fileId
                "
                alt=""
                class="img-set"
              >
              <img
                v-else
                class="img-set"
                :src="courseDetailInfo.courseCoverShow.imgShow"
                alt=""
              >
              <Icon
                type="ios-close"
                size="30"
                class="delBtn"
                @click="handleDelCover"
              ></Icon>
            </div>
            <UploadBtn
              text="上传图片"
              class="ml-2"
              :upload-type="0"
              :accept="`image/*`"
              @on-success="handleUploadImg"
            ></UploadBtn>
          </div>
          <div class="gray font-3">
            建议尺寸750*560，小于5M的JPG、PNG格式图片
          </div>
        </FormItem>
        <FormItem label="课程介绍" class="editor-sytle" prop="context">
          <!-- <div id="wangeditor" ref="wangeditor"></div> -->
          <Editor ref="editorRef" @on-create="onEditorCreate"></Editor>
          <span class="preLook" @click="showPreModalShow">预览</span>
        </FormItem>
        <FormItem label="成果展示">
          <div
            v-show="courseDetailInfo.courseAchievementShow.length"
            class="imgWrap"
          >
            <div
              v-for="(item, index) in courseDetailInfo.courseAchievementShow"
              :key="index"
              class="imgBox"
            >
              <div class="rightBox"></div>
              <img
                v-if="item.fileId"
                :src="downloadUrl + '?fileId=' + item.fileId"
                alt=""
                class="img-set"
              >
              <img v-else :src="item.imgShow" alt="" class="img-set">
              <Icon
                type="ios-close"
                size="30"
                class="delBtn"
                @click="handleDelFile(index)"
              ></Icon>
            </div>
          </div>
          <UploadBtn
            text="上传图片"
            class="upload mb-1"
            :multiple="true"
            :upload-type="1"
            :accept="`image/*`"
            @on-success="handleUploadImg1"
          ></UploadBtn>
          <div class="gray font-3">
            建议尺寸460*300，小于5M的JPG、PNG格式图片，最多上传6张
          </div>
        </FormItem>
        <FormItem label="报名须知" prop="courseNotice">
          <Input
            v-model="courseDetailInfo.courseNotice"
            type="textarea"
            placeholder="请填写"
            style="width: 100%"
            :autosize="{ minRows: 3 }"
          ></Input>
        </FormItem>
      </Form>
    </div>
    <PreLook
      :visible="preModalShow"
      :data="courseDetailInfo.context"
      @close="preModalShow = !preModalShow"
    ></PreLook>
  </div>
</template>
<script>
// import E from 'wangeditor';
import Editor from '@c/Base/Editor';
import UploadBtn from '@c/UploadBtn';
import { readFileOfImage, editorGetText, editorIsNull } from '@/utils/utils';
import { compressPic, dataURLtoFile } from '@/utils/imageHelper';
import PreLook from './PreLook.vue';
export default {
  components: {
    UploadBtn,
    PreLook,
    Editor
  },
  inject: ['AddCommodityInstance'],
  props: {
    exsitOrder: {
      type: Boolean,
      default: false
    }, // 商品是否已被购买，是否存在订单
    value: {
      type: Object,
      default: () => {
        return {
          classroomTotal: '' // 累计课时
        };
      }
    }, // v-model的值
    validatePass: {
      type: Boolean,
      default: false
    },
    downloadUrl: {
      type: String,
      default: ''
    }
  },
  data() {
    // 限制时间规则
    // const courseInfoValidate = (rule, value, callback) => {
    //   console.log(this.editor.txt.html(), '=======');
    //   callback();
    // };
    return {
      courseDetailInfoRule: {
        context: [
          { required: true, message: '请填写课程介绍', trigger: 'blur,change' }
        ],
        courseNotice: [
          { required: true, message: '请填写报名须知', trigger: 'blur' }
        ]
      },
      courseDetailInfoRequired: {},
      editor: null,
      localSrc: '', // 上传的封面图
      imgList: [],
      preModalShow: false // 是否展示预览弹窗
    };
  },
  computed: {
    courseDetailInfo: {
      get() {
        return this.value;
      },
      set(newVal) {
        this.$emit('input', newVal);
      }
    } // 课程信息
  },
  created() {
    this.dealFormRequire();
  },
  mounted() {
    // this.initE();
    this.AddCommodityInstance.findRuleRequireNewCourse(this, 'courseDetailInfo', '课程详情');
  },
  methods: {
    onEditorCreate() {},
    getFormValidate(prop, status, error) {
      this.courseDetailInfoRequired[prop].status = status;
      this.AddCommodityInstance.findRuleRequireNewCourse(this, 'courseDetailInfo', '课程详情');
    },
    dealFormRequire() {
      Object.keys(this.courseDetailInfoRule).forEach(item => {
        this.courseDetailInfoRequired[item] = {
          require: !!this.courseDetailInfoRule[item][0].required,
          status: false
        };
      });
    },
    // 校验表单
    checkForm() {
      return new Promise((resolve, reject) => {
        // this.getEditorContect();
        this.courseDetailInfo.context = this.$refs.editorRef.getEditorContext();
        this.$nextTick(() => {
          this.$refs.courseDetailInfo.validate();
          resolve();
        });
      });
    },
    initE() {
      this.editor = new E('#wangeditor');
      // 这里各位小伙伴可以查询官网，根据自己的需求进行菜单栏调整
      this.editor.config.menus = [
        'head', // 标题
        'bold', // 粗体
        'fontSize', // 字号
        'fontName', // 字体
        'italic', // 斜体
        'foreColor', // 文字颜色
        'list', // 列表
        'justify' // 对齐方式
      ];
      this.editor.config.onblur = (html) => {
        this.dealEditorContext(html);
      };
      this.editor.create();
    },
    fillEditor(context) {
      // this.editor.txt.html(context.replace(/\n/g, '<br/>'));
      this.$refs.editorRef.setEditorContext(context);
      // setTimeout(() => {
      //   this.$refs.editorRef.setEditorContext(context);
      // }, 1000);
    },
    getEditorContect() {
      this.editor.isBlur ? '' : this.dealEditorContext(this.editor.txt.html());
    },
    // 处理富文本编辑器的内容
    dealEditorContext(html) {
      this.courseDetailInfo.context = editorIsNull(editorGetText(html)) ? '' : html;
      this.$refs.courseDetailInfo.validateField('context');
      console.log(html, '执行----');
      this.AddCommodityInstance.findRuleRequireNewCourse(this, 'courseDetailInfo', '课程详情');
    },
    // 上传文件
    async handleUploadImg(files) {
      const file = files[0];
      const fileSize = file.size;
      try {
        const result = await readFileOfImage(file);
        let yaImageStr = ''; // 压缩后的base64图片
        // 如果图片大小大于200k,先进行压缩
        if (Math.round(fileSize / 1024) > 200) {
          yaImageStr = await compressPic(result, {
            quality: 0.7
          });
        } else {
          yaImageStr = result;
        }
        const newFile = dataURLtoFile(yaImageStr, file.name);
        if ((newFile.size / 1024) > 5 * 1024) {
          return this.$Message.error('图片太大！请重新上传');
        }
        const obj = {
          fileId: '',
          file: newFile,
          imgShow: yaImageStr
        };

        this.$set(this.courseDetailInfo, 'courseCoverShow', obj);
        this.$refs.courseDetailInfo.validateField('courseCoverShow');
        // this.courseDetailInfo.courseCoverShow = {
        //   fileId: '',
        //   file: file,
        //   imgShow: yaImageStr
        // };
      } catch (error) {
        this.$Message.warning('读取图片失败');
      }
    },
    showPreModalShow() {
      if (!this.preModalShow) {
        this.courseDetailInfo.context = this.$refs.editorRef.getEditorContext();
      }
      this.preModalShow = !this.preModalShow;
    },
    handleDelCover() {
      this.courseDetailInfo.courseCoverShow = null;
    },
    // 删除成果展示图片
    handleDelFile(index) {
      this.courseDetailInfo.courseAchievementShow.splice(index, 1);
    },
    // 上传多张图片
    async handleUploadImg1(files) {
      var arr = Object.keys(files);
      if (this.courseDetailInfo.courseAchievementShow + arr.length > 6) {
        this.$Message.warning('最多上传6张成果展示图片！');
        return false;
      }
      for (const key in files) {
        const file = files[key];
        const fileSize = file.size;
        try {
          const result = await readFileOfImage(file);
          let yaImageStr = ''; // 压缩后的base64图片
          // 如果图片大小大于200k,先进行压缩
          if (Math.round(fileSize / 1024) > 200) {
            yaImageStr = await compressPic(result, {
              quality: 0.7
            });
          } else {
            yaImageStr = result;
          }
          const newFile = dataURLtoFile(yaImageStr, file.name);
          if ((newFile.size / 1024) > 5 * 1024) {
            return this.$Message.error('图片太大！请重新上传');
          }
          const obj = {
            fileId: '',
            file: newFile,
            imgShow: yaImageStr
          };
          this.courseDetailInfo.courseAchievementShow.push(obj);
        } catch (error) {
          // this.$Message.warning('读取图片失败');
        }
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.editor-sytle {
  /deep/.ivu-form-item-content {
    z-index: 1;
  }
}

.preLook {
  display: inline-block;
  margin-top: 20px;
  width: 60px;
  height: 36px;
  background: rgb(247, 248, 250);
  font-size: 14px;
  text-align: center;
  line-height: 36px;
}

.head-card {
  background: rgb(247, 248, 250);
  height: 40px;
  padding-left: 20px;
  line-height: 40px;
  font-weight: 600;
  border-radius: 8px;
  margin-bottom: 20px;
}

.a-cursor {
  color: #488ffa;
  cursor: pointer;
}

.ml-8 {
  margin-left: 32px;
}

.ml-1 {
  margin-left: 4px;
}

.ml-2 {
  margin-left: 8px;
}

.mb-1 {
  margin-bottom: 4px;
}

.mb-10 {
  margin-bottom: 40px;
}

.w-121 {
  width: 484px;
}

.w-40 {
  width: 160px;
}

.w-41 {
  width: 250px;
}

.tip-flex {
  position: relative;
  // align-items: flex-start
}

.time-block {
  margin-top: 10px;
}

.tip-require {
  position: absolute;
  left: 13px;
  margin-top: 10px;
  // line-height: 38px;
  color: #ed4014;
  font-size: 14px;
  font-family: SimSun;
}

.tip-erro /deep/ .ivu-form-item-error-tip {
  top: 3px;
  left: 200px;
}
.type /deep/ .ivu-form-item-error-tip {
  left: 265px;
}

.tip-erro-short /deep/ .ivu-form-item-error-tip {
  top: 3px;
  left: 200px;
}

.tip-erro-long /deep/ .ivu-form-item-error-tip {
  top: 3px;
  left: 500px;
}

.tip-erro /deep/ .ivu-form-item-content {
  margin-bottom: 25px;
}

.classDate /deep/ .ivu-form-item-content {
  margin-bottom: 10px;
}

.font-black {
  color: black;
}

.tip {
  color: gray;
  position: absolute;
  top: 42px;
}

.relative {
  position: relative;
}

.add-btn {
  width: 95px;
  height: 30px;
  border: 1px dashed transparent;
  background: linear-gradient(white, white) padding-box,
    repeating-linear-gradient(
      -45deg,
      #488ffa 0,
      #488ffa 0.5em,
      white 0,
      white 0.75em
    );
  color: #488ffa;
  border-radius: 4px;
  text-align: center;
  line-height: 30px;

  .icon {
    margin-right: 2px;
  }
}

.justify-center {
  display: flex;
  justify-content: center;
}

.img-set {
  // width: 100px;
  height: 100px;
}

.flex {
  display: flex;
}

.upload {
  align-items: flex-end;
}

.gray {
  color: gray;
}

.font-3 {
  font-size: 12px;
}

.imgWrap {
  display: flex;
  max-width: 400px;
  flex-wrap: wrap;
  // justify-content: flex-start;
  align-items: flex-end;

  // margin-bottom: 20px;
}
.imgBox {
  position: relative;
  margin: 5px 10px;

  // border: 1px solid #e5e5e5;
  .rightBox {
    width: 20px;
    height: 20px;
    background-color: rgba(0, 0, 0, 0.7);
    border-radius: 0 0 0 12px;
    position: absolute;
    top: 0;
    right: 0;
  }

  .delBtn {
    position: absolute;
    top: -5px;
    right: -5px;
    color: #fff;
    cursor: pointer;
  }
}

.book-title {
  background-color: rgb(247, 248, 250);
  font-weight: 700;

  tr {
    border: 1px solid rgb(247, 248, 250);
  }
}

.book {
  line-height: 50px;
  text-indent: 10px;
}

.w100 {
  width: 100px;
}

.w200 {
  width: 200px;
}

.w1000 {
  width: 1000px;
}

.bg {
  background-color: rgb(247, 248, 250);
}
</style>
